import { FC, useEffect, useState } from 'react'
import GlobalSpinner from '../globalsSpinner/GlobalSpinner';
import { FormRowHorizontal } from '../formRow/FormRow';
import { Button } from '../Button';
import { PrivacyInfo, getPrivacyInfo, patchPrivacyInfo } from '../../../api/playersApi';
import { useParams } from 'react-router-dom';
import FormCheckbox from '../formRow/FormCheckbox';

const Privacy:FC = () => {
    let [isLoading, setIsLoading] = useState(false)

    let [isTracking, setIsTracking] = useState(false)
    let [isGDPR, setIsGDPR] = useState(false)

    let {id : playerId} = useParams<{id:string}>();

    useEffect(() => {
        async function fetchData(){
            setIsLoading(true);
            await updatePrivacyInfo()
            setIsLoading(false);
        }

        fetchData()
    }, [])

    const updatePrivacyInfo = async () => {
        let result = await getPrivacyInfo(playerId)
        if (result.type == "succes") {
            setIsTracking(result.data.data.tracking);
            setIsGDPR(result.data.data.gdpr);
        }
    }

    const savePrivacyInfo = async () => {

        let request: PrivacyInfo = {
            tracking: isTracking,
            gdpr: isGDPR,
        }

        setIsLoading(true)
        await patchPrivacyInfo(playerId, request);
        await updatePrivacyInfo()
        setIsLoading(false)
    }

    return <>
        <div className="privacy-block" style={{width:500}}>
            <FormRowHorizontal>
                <label>Tracking</label>
                <div className="status-container">
                    <span className="status-block">
                        {isTracking ? <span className="current-status online">Allow</span> : <span className="current-status offline">Not allow</span>}
                    </span>
                    <FormCheckbox id="tracking" checked={isTracking} onChange={setIsTracking} />
                </div>
            </FormRowHorizontal>
            <FormRowHorizontal>
                <label>GDPR</label>
                <div className="status-container">
                    <span className="status-block">
                        {isGDPR ? <span className="current-status online">Apply</span> : <span className="current-status offline">Not apply</span>}
                    </span>
                    <FormCheckbox id="gdpr" checked={isGDPR} onChange={setIsGDPR} />
                </div>
            </FormRowHorizontal>
            
            <div className="form-btn">
                <Button color="green" label="Save" onClick={savePrivacyInfo} />
            </div>
        </div>
        <GlobalSpinner isShow={isLoading} />
    </>
}

export default Privacy